import {ApiClientCommunication} from 'neo-common';

/**
 * enum LaunchAction - possible launch actions
 */
export enum LaunchAction {
    /**
     * Device / player is allowed to continue to channel
     */
    Allow = <any>'allow',

    /**
     * Device / player is allowed to continue to channel with warning message displayed
     */
    Warning = <any>'warning',

    /**
     * Device / player is denied to continue to channel with error message displayed
     */
    Deny = <any>'deny'
}

export class LaunchClientResponse extends ApiClientCommunication.ResponseBase {
    /**
     * @property data - parameters object from which query string parameters is used to redirect to game index.html.
     */
    data: Object;

    /**
     * @property fragment - fragment part of query string.
     */
    fragment: string;

    /**
     * @property action - Launch action
     */
    action: LaunchAction;

    /**
     * @property message - message to show in case action is not 'Allow'
     */
    message: string;

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Launch/LaunchClientResponse.ts
 **/